import React from 'react';

interface Props {
  mode?: 'list' | 'card';
}

const placeholders = Array.from({ length: 8 });

const POSProductPlaceholder: React.FC<Props> = ({ mode = 'list' }) => {
  // =====================================================
  // 🔹 Card Mode
  // =====================================================

  if (mode === 'card') {
    return (
      <div
        className="
          grid
          grid-cols-1
          gap-3

          sm:grid-cols-2
          md:grid-cols-3
          lg:grid-cols-4
          xl:grid-cols-5
          2xl:grid-cols-5
        "
      >
        {placeholders.map((_, index) => (
          <div
            key={index}
            className="
              overflow-hidden

              rounded-xl
              border

              border-stroke

              bg-whiten

              shadow-default

              dark:border-strokedark
              dark:bg-boxdark
            "
          >
            {/* 🔹 Image */}

            <div
              className="
                h-[150px]

                bg-slate-200

                dark:bg-meta-4
              "
            />

            {/* 🔹 Content */}

            <div className="space-y-3 p-4">
              <div
                className="
                  h-3
                  w-16

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />

              <div
                className="
                  h-4
                  w-full

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />

              <div
                className="
                  h-4
                  w-2/3

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />

              <div
                className="
                  h-5
                  w-24

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />

              <div
                className="
                  h-3
                  w-20

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />
            </div>
          </div>
        ))}
      </div>
    );
  }

  // =====================================================
  // 🔹 List Mode
  // =====================================================

  return (
    <div className="space-y-2">
      {placeholders.map((_, index) => (
        <div
          key={index}
          className="
            overflow-hidden

            rounded-xl
            border

            border-stroke

            bg-whiten

            shadow-default

            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          <div
            className="
              flex
              flex-col
              gap-4

              p-4

              sm:h-[88px]
              sm:flex-row
              sm:items-center
              sm:gap-0
            "
          >
            {/* 🔹 Image */}

            <div
              className="
                h-14
                w-14

                shrink-0

                rounded-xl

                bg-slate-200

                dark:bg-meta-4
              "
            />

            {/* 🔹 Content */}

            <div
              className="
                flex-1

                space-y-2

                sm:ml-4
              "
            >
              <div
                className="
                  h-4
                  w-2/3

                  rounded

                  bg-slate-200

                  dark:bg-meta-4

                  sm:w-2/5
                "
              />

              <div
                className="
                  h-3
                  w-1/3

                  rounded

                  bg-slate-200

                  dark:bg-meta-4

                  sm:w-1/4
                "
              />
            </div>

            {/* 🔹 Price + Stock */}

            <div
              className="
                flex
                items-center
                justify-between
                gap-4

                sm:ml-6
                sm:justify-end
              "
            >
              {/* 🔹 Price */}

              <div
                className="
                  h-5
                  w-20

                  rounded

                  bg-slate-200

                  dark:bg-meta-4
                "
              />

              {/* 🔹 Stock */}

              <div
                className="
                  h-8
                  w-24

                  rounded-lg

                  bg-slate-200

                  dark:bg-meta-4
                "
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default POSProductPlaceholder;